import { render, staticRenderFns } from "./StatusBarView.vue?vue&type=template&id=70d6e7b0&scoped=true&"
import script from "./StatusBarView.vue?vue&type=script&lang=ts&"
export * from "./StatusBarView.vue?vue&type=script&lang=ts&"
import style0 from "./StatusBarView.vue?vue&type=style&index=0&id=70d6e7b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d6e7b0",
  null
  
)

export default component.exports